import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'bn-web-ui-color-picker-color',
  styleUrls: ['color-picker-color.component.scss'],
  templateUrl: './color-picker-color.component.html',
  imports: [NgClass],
})
export class ColorPickerColorComponent {
  public combinedColor?: string;

  @Input()
  public color!: string;

  @Input()
  public set selectedColor(selectedColor: string | undefined) {
    this.combinedColor = selectedColor ? this.combineColor(selectedColor) : selectedColor;
  }

  public combineColor(color: string): string {
    const fullColor = color.length === 4 ? Array.from(color.substring(1)).map((char: string) => char + char) : Array.from(color.substring(1));

    return `#${fullColor.join('')}`;
  }
}
